import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { useI18n } from '../../../i18n/services/i18n.service';
import { NationalIdDocumentType } from '../../model/customer-information.model';
import { IdentityField } from '../../model/identity-field.model';
import { FeatureVisibilityService } from '../../services/feature-visibility.service';

@Component({
  selector: 'cdf-personal-identification-numbers',
  template: `
    @if (!featureVisibilityService.isHidden(IdentityField.TAX_NUMBER) && taxNumber()) {
      <div>
        <span class="text-label text-neutral">{{ i18n('personalIdentificationNumbers.taxNumber') }}:</span>
        &ngsp;
        <span id="tax-number" class="text-label value">{{ taxNumber() }}</span>
      </div>
    }
    @if (!featureVisibilityService.isHidden(IdentityField.NATIONAL_ID) && nationalId1()) {
      <div>
        <span id="national-id-label" class="text-label text-neutral">{{ nationalId1Label() }}:</span>
        &ngsp;
        <span id="national-id" class="text-label value">{{ nationalId1() }}</span>
      </div>
    }
  `,
  styleUrl: './personal-identification-numbers.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersonalIdentificationNumbersComponent {
  protected readonly i18n = useI18n();
  protected readonly featureVisibilityService = inject(FeatureVisibilityService);

  readonly nationalId1 = input.required<string | undefined>();
  readonly nationalId1DocumentType = input.required<NationalIdDocumentType | undefined>();
  readonly taxNumber = input.required<string | undefined>();

  protected readonly nationalId1Label = computed(() => {
    const documentType = this.nationalId1DocumentType();
    if (documentType) {
      return this.i18n.enum(documentType, 'nationalIdDocumentType');
    }
    return this.i18n('personalIdentificationNumbers.nationalId');
  });

  protected readonly IdentityField = IdentityField;
}
